import React, { useEffect, useState } from "react";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import ApplicationUtil from "../../../../../utils/ApplicationUtil";
import { withRouter } from "react-router-dom";
import {
  getTeamAndGroupNames,
  getTeamList,
  deleteTeamApi,
} from "../../../../../apis/eventService";
import GoldMedal from "../../../../../images/gold-medal.png";
import SilverMedal from "../../../../../images/silver-medal.png";
import BronzeMedal from "../../../../../images/bronze-medal.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import BoardList from "../../../registration/events/viewResults/Leaderboard/BoardList";
import GroupIcon from "@material-ui/icons/Group";
import SearchIcon from "@material-ui/icons/Search";
import SubmitCancelBtn from "../../../../common/SubmitCancelBtn";
import Snackbar from "../../../../common/Snackbar";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const styles = (theme) => ({
  winnerTeamsContainer: {
    marginTop: "30px",
    display: "flex",
    alignItems: "flex-start",
    "& .teamLayout": {
      color: "#ffffff",
      backgroundColor: "#0077b6",
      borderRadius: "0",
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0px",
    },
    "& .teamWinner1": {
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        // width: "89%",
      },
    },
    "& .teamWinner2": {
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        // width: "89%",
      },
    },
    "& .teamWinner3": {
      width: "100%",
      marginBottom: "10px",
      [theme.breakpoints.down("sm")]: {
        // width: "89%",
      },
    },

    "& .medalIcons": {
      height: 60,
      width: 60,
      objectFit: "contain",
      [theme.breakpoints.down("sm")]: {
        height: 35,
        width: 35,
      },
    },
  },
  teamListLeftSpace: {
    width: "60px",
    height: "60px",
    [theme.breakpoints.down("sm")]: {
      height: 35,
      width: 35,
    },
  },
  teamListContainer: {
    marginTop: "20px",
    "& .teamList": {
      borderRadius: "0",
      backgroundColor: "#0077b6",
      color: "#ffffff",
      [theme.breakpoints.down("sm")]: {
        // marginLeft: "10%",
        // width: "89%",
      },
    },
    "& .accordion": {
      cursor: "none",
      "& .MuiIconButton-root": {
        visibility: "hidden",
      },
    },
  },
  winnerIconsContainer: {
    display: "flex",
    alignItems: "center",
  },
  noTeam: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "100px",
  },
  searchRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    paddingLeft: theme.spacing(6),
    paddingRight: "1px",
    marginTop: theme.spacing(1),

    columnGap: "12px",
    flexWrap: "nowrap",

    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      flexWrap: "wrap",
      rowGap: "10px",
    },

    "& .search": {
      display: "flex",
      alignItems: "center",
      border: "1px solid #bfc0c0",
      borderRadius: "5px",
      height: "35px",

      width: 320,
      flex: "0 0 320px",
      maxWidth: "100%",
      minWidth: 0,

      [theme.breakpoints.down("sm")]: {
        width: "100%",
        flex: "1 1 100%",
      },

      "& > input": {
        flex: 1,
        minWidth: 0,
        height: "30px",
        outline: "none",
        border: "none",
        fontSize: "16px",
        paddingLeft: "10px",
        borderRight: "2px solid #bfc0c0",
      },

      "& .search__icon": {
        padding: "5px",
        cursor: "pointer",
        flexShrink: 0,
      },
    },

    "& .createTeamBtn": {
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
  },

  deleteBtn: {
    padding: 6,
    marginLeft: 6,
    color: "#ffffff",
    opacity: 0.95,
    "&:hover": {
      opacity: 1,
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  },
  editBtn: {
    padding: 6,
    marginLeft: 4,
    color: "#ffffff",
    opacity: 0.95,
    "&:hover": {
      opacity: 1,
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  },

  dialogText: {
    fontSize: 16,
  },
  dialogPaper: {
    borderRadius: 10,
  },
  dialogTitle: {
    fontFamily: "Rubik, sans-serif",
    fontWeight: 700,
    color: "#09456C",
    paddingBottom: 6,
  },
  dialogContent: {
    paddingTop: 0,
    fontFamily: "Rubik, sans-serif",
  },
  dialogActions: {
    padding: "8px 20px 18px",
  },
  btnCancel: {
    borderRadius: 8,
    fontWeight: 700,
    textTransform: "uppercase",
    border: "1px solid #09456C",
    color: "#09456C",
  },
  btnDelete: {
    borderRadius: 8,
    fontWeight: 700,
    textTransform: "uppercase",
    backgroundColor: "#09456C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#073652",
    },
    "&:disabled": {
      opacity: 0.7,
      color: "#fff",
    },
  },
});

function OrganizerTeams(props) {
  const { classes, history } = props;
  const eventData = ApplicationUtil.getSupportsEventsDetails();
  const enableTeamSetting = eventData?.eventSettings?.orgnizerEnableTeamSetting;
  let userRole = localStorage.getItem("role");
// The button shows if:
// 1. The user is NOT an admin (it always displays for them)
// 2. OR the user IS an admin AND the flag is "true"
const shouldShowSetting = userRole !== "ORGANIZER_ADMIN" || enableTeamSetting === "true";

  const [teamWinnersData, setTeamWinnersData] = useState(null);
  const [teamData, setTeamData] = useState(null);
  const [teamListData, setTeamListData] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [challengeParameter, setChallengeParameter] = useState("DISTANCE");
  const [searchText, setSearchText] = useState("");

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({ id: null, name: "" });

  const fetchTeams = (text = "") => {
    let eventId = ApplicationUtil.getSupportsEventID();

    setExpanded(false);
    setTeamListData([]);

    getTeamAndGroupNames(eventId, "TEAMS", text).then((res) => {
      if (res.data) {
        let data = res.data;
        let winnersData = data?.teamDetails?.filter(
          (x) => x.teamRank == 1 || x.teamRank == 2 || x.teamRank == 3,
        );
        let restTeams = data?.teamDetails?.filter((x) => x.teamRank > 3);

        setTeamWinnersData(data?.teamDetails?.length > 0 ? winnersData : []);
        setTeamData(restTeams);

        if (data?.challengeParameter) {
          setChallengeParameter(data?.challengeParameter);
        }
      }
    });
  };

  const onSearchChange = (e) => {
    const val = e.target.value;
    setSearchText(val);
    if (!val) fetchTeams("");
  };

  const onSearchSubmit = () => {
    fetchTeams(searchText);
  };

  useEffect(() => {
    fetchTeams("");
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    if (!isExpanded) {
      setExpanded(false);
      return;
    }

    let eventId = ApplicationUtil.getSupportsEventID();
    let requestParams = {
      eventId: eventId,
      teamId: panel,
      leaderboard: false,
    };
    getTeamList(requestParams).then((res) => {
      if (res.data) {
        let data = res.data;
        setTeamListData(data?.teamMemberActivities);
      }
    });

    setExpanded(panel ? (isExpanded ? panel : false) : false);
  };

  const navigateToDetails = (id) => {
    localStorage.setItem("supportRunnerId", id);
    history.push("list/details");
  };

  const openDeleteDialog = (e, team) => {
    e.preventDefault();
    e.stopPropagation();

    setDeleteTarget({ id: team?.id, name: team?.teamName || "" });
    setDeleteOpen(true);
  };

  const closeDeleteDialog = () => {
    if (deleting) return;
    setDeleteOpen(false);
    setDeleteTarget({ id: null, name: "" });
  };

  const confirmDelete = () => {
    const teamId = deleteTarget?.id;
    if (!teamId) return;

    setDeleting(true);
    deleteTeamApi(teamId)
      .then((res) => {
        Snackbar.show({
          variant: "success",
          isAutoHide: true,
          preventDuplicate: true,
          message: res?.data?.verbose || "Team deleted successfully.",
        });

        // refresh list
        closeDeleteDialog();
        fetchTeams(searchText || "");
      })
      .catch((err) => {
        Snackbar.show({
          variant: "error",
          isAutoHide: true,
          preventDuplicate: true,
          message:
            err?.response?.data?.verbose ||
            err?.response?.data?.message ||
            "Failed to delete team.",
        });
      })
      .finally(() => setDeleting(false));
  };
  const openEditTeam = (e, team) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(`/organizer/list/createTeam?teamId=${team?.id}`);
  };

  return (
    <div>
      <div className={classes.searchRow}>
        <form
          className="search"
          onSubmit={(e) => {
            e.preventDefault();
            onSearchSubmit();
          }}
        >
          <input
            type="search"
            placeholder="Search..."
            value={searchText}
            onChange={onSearchChange}
          />
          <SearchIcon className="search__icon" onClick={onSearchSubmit} />
        </form>

        {shouldShowSetting && (
          <div className="createTeamBtn">
            <SubmitCancelBtn
              style={{ borderRadius: "10px" }}
              label="Create Team"
              type="submit"
              onClick={() => history.push("/organizer/list/createTeam")}
            />
          </div>
        )}
      </div>

      <div style={{ padding: "16px 16px" }}>
        {teamWinnersData?.length > 0 && (
          <div>
            {teamWinnersData?.map((team) => (
              <div
                key={team?.teamRank}
                className={classes.winnerTeamsContainer}
              >
                <div className={classes.winnerIconsContainer}>
                  <img
                    src={
                      team?.teamRank === 1
                        ? GoldMedal
                        : team?.teamRank === 2
                          ? SilverMedal
                          : BronzeMedal
                    }
                    alt="medal"
                    className="medalIcons"
                  />
                </div>

                <Accordion
                  className={`teamLayout teamWinner${team?.teamRank}`}
                  expanded={expanded === team?.id}
                  onChange={handleChange(team?.id)}
                >
                  <AccordionSummaryContainer
                    team={team}
                    challengeParameter={challengeParameter}
                    onDelete={openDeleteDialog}
                    onEdit={openEditTeam}
                    isTeamSettingDisabled={shouldShowSetting}
                    classes={classes}
                  />

                  <AccordionDetails className={classes.accordionDetails}>
                    {teamListData?.length > 0 && (
                      <BoardList
                        challengeParameter={challengeParameter}
                        distance={challengeParameter === "DISTANCE"}
                        time={challengeParameter === "DISTANCE"}
                        sort
                        data={teamListData}
                        onClick={navigateToDetails}
                        teamLeaderId={team?.teamLeaderId}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          </div>
        )}

        {teamData?.length > 0 && (
          <>
            {teamData.map((team) => (
              <div key={team.id} className={classes.teamListContainer}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div className={classes.teamListLeftSpace}></div>
                  <Accordion
                    expanded={expanded === team.id}
                    onChange={handleChange(team.id)}
                    className="teamList"
                    style={{ flex: 1 }}
                  >
                    <AccordionSummaryContainer
                      team={team}
                      isTeamSettingDisabled={shouldShowSetting}
                      challengeParameter={challengeParameter}
                      radioValue={"team"}
                      onEdit={openEditTeam}
                      onDelete={openDeleteDialog}
                      classes={classes}
                    />

                    <AccordionDetails className={classes.accordionDetails}>
                      {teamListData?.length > 0 && (
                        <BoardList
                          challengeParameter={challengeParameter}
                          distance={challengeParameter === "DISTANCE"}
                          time={challengeParameter === "DISTANCE"}
                          sort
                          data={teamListData}
                          onClick={navigateToDetails}
                          teamLeaderId={team?.teamLeaderId}
                          style={{ width: "100%" }}
                        />
                      )}
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            ))}
          </>
        )}

        {teamWinnersData?.length === 0 && teamData?.length === 0 && (
          <div className={classes.noTeam}>
            <GroupIcon style={{ width: 200, height: 200, color: "gray" }} />
            <span style={{ fontSize: 18, fontWeight: 600, color: "gray" }}>
              Teams not found.
            </span>
          </div>
        )}
      </div>
      <Dialog
        open={deleteOpen}
        onClose={closeDeleteDialog}
        maxWidth="xs"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>Delete Team</DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <Typography style={{ fontSize: 15, color: "#4b5563" }}>
            Are you sure you want to delete team{" "}
            <b style={{ color: "#111827" }}>{deleteTarget?.name || ""}</b>?
          </Typography>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={closeDeleteDialog}
            disabled={deleting}
            className={classes.btnCancel}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            onClick={confirmDelete}
            disabled={deleting}
            className={classes.btnDelete}
            variant="contained"
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const AccordionSummaryData = ({ value, align }) => {
  return (
    <Grid
      item
      style={{
        textAlign: align ? align : "left",
        fontSize: window.innerWidth >= 600 ? "18px" : "16px",
      }}
    >
      <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
        {value}{" "}
      </span>
    </Grid>
  );
};

const AccordionSummaryContainer = ({
  team,
  challengeParameter,
  onDelete,
  classes,
  onEdit,
  isTeamSettingDisabled,
}) => {
  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon style={{ color: "#ffffff" }} />}
    >
      <Grid container alignItems="center">
        <Grid item xs={6}>
          <AccordionSummaryData value={team?.teamName} />
        </Grid>

        {challengeParameter === "DISTANCE" && (
          <Grid item xs={3}>
            <AccordionSummaryData
              value={parseFloat(team?.teamDistance / 1000).toFixed(2) + " Km"}
              align={"center"}
            />
          </Grid>
        )}

        {challengeParameter === "CALORIE" && (
          <Grid item xs={3}>
            <AccordionSummaryData
              value={team?.teamTotalCalories}
              align="center"
            />
          </Grid>
        )}

        {challengeParameter === "STEPS" && (
          <Grid item xs={3}>
            <AccordionSummaryData value={team?.teamTotalSteps} align="center" />
          </Grid>
        )}

        {challengeParameter === "ELEVATION" && (
          <Grid item xs={3}>
            <AccordionSummaryData
              value={team?.teamTotalElevationGain}
              align="center"
            />
          </Grid>
        )}

        {challengeParameter === "WELLNESS_POINT" && (
          <Grid item xs={3}>
            <AccordionSummaryData
              value={team?.teamTotalWellnessPoint}
              align="center"
            />
          </Grid>
        )}

        <Grid item xs={2}>
          <AccordionSummaryData value={team?.teamRank} align={"center"} />
        </Grid>

        {isTeamSettingDisabled && (
          <Grid
            item
            xs={1}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <IconButton
              className={classes.editBtn}
              onClick={(e) => onEdit(e, team)}
              aria-label="edit-team"
            >
              <EditOutlinedIcon />
            </IconButton>

            <IconButton
              className={classes.deleteBtn}
              onClick={(e) => onDelete(e, team)}
              aria-label="delete-team"
            >
              <DeleteOutlineIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </AccordionSummary>
  );
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
)(OrganizerTeams);
